import BaseViewModel from './BaseViewModel';

class CustomerSelectViewModel extends BaseViewModel {
	typeId = 'CustomerSelect';
	filterType = null;
	typeSelectLabel = 'Тип заявителя';
	customerTypes = [
		{
			title: 'Все',
			text: 'Все',
			type: 'All',
			id: 'All',
		},
		{
			title: 'Физическое лицо',
			text: 'Физическое лицо',
			type: 'Physical',
			id: 'Physical',
		},
		{
			title: 'Юридическое лицо',
			text: 'Юридическое лицо',
			type: 'Juridical',
			id: 'Juridical',
		},
		{
			title: 'Индивидуальный предприниматель',
			text: 'Индивидуальный предприниматель',
			type: 'Individual',
			id: 'Individual',
		},
		{
			title: 'Иностранный гражданин',
			text: 'Иностранный гражданин',
			type: 'Foreign',
			id: 'Foreign',
		},
	];
}

export default CustomerSelectViewModel;
